import axios, { AxiosResponse, AxiosError } from 'axios'
import { MAmmunition } from '@Models/client/ammunition.model'
import { ICommonQuery, IUpdate } from '@Models/common.model'
import * as Redux from 'redux'
import { ClientActionTypes } from '@ClientStores/client.action-types'
import SharedActions from '@SharedActions/loading.action'
import { APIServices } from '@Services/api.service'
import { ToastServices } from '@Services/toast.service'

const AMMUNITION = '/items/static-ammunition'

const getAmmunition = (params?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setClientLoading(true) as any)
        APIServices.axiosConfig()
        axios
            .get(AMMUNITION, {
                params: { ...params, type: 'AMMUNITION', isDetail: true },
            })
            .then((response: AxiosResponse) => {
                const { data, metadata } = response?.data
                const formattedData = data?.map(
                    (item: MAmmunition) => new MAmmunition(item)
                )
                const payload = { data: formattedData, metadata }
                dispatch({ type: ClientActionTypes.GET_AMMUNITION, payload })
                dispatch(SharedActions.setClientLoading(false) as any)
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                dispatch(SharedActions.setClientLoading(false) as any)
            })
    }
}

const addAmmunition = (body: any) => {
    return (dispatch: Redux.Dispatch) => {
        return new Promise((resolve, reject) => {
            axios
                .post(AMMUNITION, body)
                .then((response: AxiosResponse) => {
                    ToastServices.success('Ammunition created')
                    dispatch(getAmmunition() as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const updateAmmunition = (payload: IUpdate<any>) => {
    return (dispatch: Redux.Dispatch) => {
        return new Promise((resolve, reject) => {
            axios
                .put(`${AMMUNITION}/${payload?.id}`, payload?.payload)
                .then((response: AxiosResponse) => {
                    ToastServices.success('Ammunition updated')
                    dispatch(getAmmunition() as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const ClientAmmunitionActions = {
    getAmmunition,
    addAmmunition,
    updateAmmunition,
}

export default ClientAmmunitionActions
